import { Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";

const ViewAnomalyGuideDialogBody = (item: unknown) => {
  const { t } = useTranslation();
  const dialogItem = (item ?? {}) as Record<string, unknown>;
  const category = typeof dialogItem.category === "string" ? dialogItem.category : "";
  const subCategory = typeof dialogItem.subCategory === "string" ? dialogItem.subCategory : "";
  const classificationGuidance =
    typeof dialogItem.classificationGuidance === "string" ? dialogItem.classificationGuidance : "";

  return (
    <DrawerForm>
      <DrawerFormSection title={t("anomalyGuides.form.category")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="id"
              name="id"
              label={t("anomalyGuides.form.id")}
              variant="outlined"
              size="small"
              value={String(dialogItem.id || "")}
              slotProps={{ input: { readOnly: true } }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              fullWidth
              id="category"
              name="category"
              label={t("anomalyGuides.form.category")}
              variant="outlined"
              size="small"
              value={category}
              slotProps={{ input: { readOnly: true } }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              fullWidth
              id="subCategory"
              name="subCategory"
              label={t("anomalyGuides.form.subcategory")}
              variant="outlined"
              size="small"
              value={subCategory}
              slotProps={{ input: { readOnly: true } }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="classificationGuidance"
              name="classificationGuidance"
              label={t("anomalyGuides.form.classificationGuidance")}
              variant="outlined"
              size="small"
              multiline
              rows={6}
              value={classificationGuidance}
              slotProps={{ input: { readOnly: true } }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default ViewAnomalyGuideDialogBody;
